// Figure out build mode so we can determine available themes
const isLocalBuild = import.meta.env.VITE_APP_ENVIRONMENT === "local";
const isAtlasBuild = import.meta.env.VITE_ATLAS_BUILD === "1";

import { IThemeConfig, THEMES } from "../constants";

// Figure out what themes are available based on build mode
export const getAvailableThemes = (): IThemeConfig[] => {
  const availableThemes: IThemeConfig[] = [];
  Object.entries(THEMES).forEach(([_, themeConfig]) => {
    let isAvailable = false;

    if (isAtlasBuild) {
      // Include Atlas themes in Atlas builds
      if (themeConfig.availableModes?.includes("atlas")) {
        isAvailable = true;
      }
    } else {
      // Include legacy themes in non-Atlas builds
      if (themeConfig.availableModes?.includes("legacy")) {
        isAvailable = true;
      }
    }
    // Include "local" mode themes in local builds
    if (isLocalBuild && themeConfig.availableModes?.includes("local")) {
      isAvailable = true;
    }
    if (isAvailable) {
      availableThemes.push(themeConfig);
    }
  });

  return availableThemes;
};
